import { Judgement } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNominationJudgement: (
  fetchContext: FetchContext,
  nominationId: number,
  userId: number,
  judgement: Judgement,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, userId, judgement, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/nominations/${nominationId}/judges/${userId}/judgement`,
  {
    method: 'PUT',
    body: JSON.stringify(judgement),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update nomination judgement'));
